export default function createPublicImageUrl(url: string | null | undefined) {
  if (url == null) return;

  return `${import.meta.env.VITE_KNOWZ_FILES_URL}/${url}`;
}

export function retrieveImageWithFallback(
  imageUrl: string | null | undefined,
  placeholderUrl: string,
) {
  if (imageUrl == null) {
    return placeholderUrl;
  }

  return imageUrl;
}
